import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { WorkforceService } from 'src/app/services/workforce.service';
import { WorkforceGroup, WFWorker } from 'src/app/store/events.era';

@Component({
    selector: 'add-workforce-to-group-dialog',
    template: `
  <div class="add-workforce-to-group-dialog joi-dialog">
      <div mat-dialog-title>Add to a Group!</div>
      <div mat-dialog-content>
          <div class="label" [innerHTML]="title"></div>
          <div class="group" *ngFor="let group of wf_groups; index as i">
              <div class="name">
                  <mat-checkbox color="primary" (change)="selectGroup($event, i)" [disabled]="disabledGroups[i]">{{group.realName}}</mat-checkbox>
              </div>
          </div>
      </div>
      <div mat-dialog-actions>
          <div style="flex:1;"></div>
          <button mat-button (click)="dialogRef.close()">CANCEL</button>
          <button mat-button color="primary" [disabled]="selected_groups.length==0" (click)="saveGroups()" tabindex="1">Add</button>
      </div>
  </div>
  `,
    styleUrls: [`./workforce.main.scss`],
    standalone: true,
    imports: [MatCheckboxModule, MatDialogModule, MatButtonModule, CommonModule],
})
export class AddWorkforceToGroupDialogComponent {

  title = '';
  selected_groups = [];
  disabledGroups = [];
  selectedWorkers: WFWorker[] = []
  wf_groups: WorkforceGroup[] = []
  constructor(public dialogRef: MatDialogRef<AddWorkforceToGroupDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private workforce: WorkforceService) {
    const { workers, wf_groups } = data
    const selectedWorkers = workers.filter(w => w.selected)
    this.disabledGroups = wf_groups.map(g => {
      let canSelectGroup = false
      selectedWorkers.forEach(w => {
        if (!g.members.includes(w.email)) {
          canSelectGroup = true
          return
        }
      })
      return !canSelectGroup
    })
    const { firstName, lastName, email } = data.workers.find(w=>w.selected);
    const selected_array = data.workers.filter(w=>w.selected);
    this.title = selectedWorkers.length === 1 ? 'Add <b>' + firstName + ' ' + lastName + '</b> (' + email + ') to:' : 'Add ' + selected_array.length + ' selected workforce members to:'
    this.wf_groups = wf_groups
    this.selectedWorkers = selectedWorkers
  }
  selectGroup(evt, i) {
    const idx = this.selected_groups.indexOf(i);
    if (evt.checked && idx < 0) {
      this.selected_groups.push(i);
    } else if (!evt.checked && idx > -1) {
      this.selected_groups.splice(idx, 1);
    }
    // console.log(this.selected_groups);
  }
  saveGroups() {
    // only saves selected groups.  This is to avoid the issue of unselecting people from groups inadvertently (for example, 1 / 4 selected workers belong to a group, but if you hit "modify", it would unselect that worker from that group if it wasn't selected)
    let changes = 0
    this.selected_groups.forEach(index => { // <== there is a lot of mutating in place happening here, maybe not the best way to handle this
      const wf_group = this.wf_groups[index]
      this.selectedWorkers.forEach(({ email, groups }) => {
        if (!wf_group.members.includes(email)) {
          wf_group.members.push(email)
          groups.push(wf_group.name)
          changes++
        }
      })
    })
    if (!changes) {
      return
    }
    this.workforce.upsertWorkforceGroups(this.wf_groups).then(results => {
      this.dialogRef.close()
    }).catch(err => {
      console.error("Error: ", { err })
    })
  }

}
